import { useQuery } from "@tanstack/react-query";

import { AnalyticsStatsCard } from "components/analytics/display-card";
import { AnalyticsStatsCardPlaceholder } from "components/analytics/placeholder";

import { timesheetKeys } from "components/timesheet/queries";

import { Separator } from "ui/components/separator";
import { formatHoursToTime } from "utils/timesheet";
import { calculateTotalHours } from "utils/utils";
import { fetchPendingReviewEntriesForProjectCoordinator } from "./api";

export function ProjectCoordinatorsPendingReviewHoursCard() {
  const { data, isLoading } = useQuery({
    queryKey: timesheetKeys.pendingProjectReviewHours(),
    queryFn: fetchPendingReviewEntriesForProjectCoordinator,
    select: (data) => calculateTotalHours(data, "logged_hours"),
  });
  console.log(data);

  if (isLoading) return <AnalyticsStatsCardPlaceholder />;
  return (
    <AnalyticsStatsCard
      label="Pending Review Hours"
      value={formatHoursToTime(data)}
    />
  );
}
